import Act1_Myyja from '../../images/svg/Act1_Myyja.svg'
import Act2_Myyja from '../../images/svg/Act2_Myyja.svg'
import Act3_Myyja from '../../images/svg/Act3_Myyja.svg'
import Act4_Myyja from '../../images/svg/Act4_Myyja.svg'
import Act5_Myyja from '../../images/svg/Act5_Myyja.svg'

import Act1_Vastaaja from '../../images/svg/Act1_Vastaaja.svg'
import Act2_Vastaaja from '../../images/svg/Act2_Vastaaja.svg'
import Act3_Vastaaja from '../../images/svg/Act3_Vastaaja.svg'
import Act4_Vastaaja from '../../images/svg/Act4_Vastaaja.svg'
import Act5_Vastaaja from '../../images/svg/Act5_Vastaaja.svg'

import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import './Act.css'

const Act = () => {
    const [act, setAct] = useState(Act1_Myyja)
    const reduxStage = useSelector(state => state.stage)
    const role = useSelector(state => state.role)

    useEffect(() => {
        if (role === 'seller') {
            setSeller()
            return
        }

        setBuyer()
        // eslint-disable-next-line
    }, [reduxStage])

    const setSeller = () => {

        if (reduxStage === '1') {
            setAct(Act1_Myyja)
            return
        }

        if (reduxStage === '2') {
            setAct(Act2_Myyja)
            return
        }

        if (reduxStage === '3') {
            setAct(Act3_Myyja)
            return
        }

        if (reduxStage === '4') {
            setAct(Act4_Myyja)
            return
        }

        if (reduxStage === '5') {
            setAct(Act5_Myyja)
            return
        }
        /*
        jostain syystä ei toimi...
        switch (reduxStage) {
            case '1':
                setAct(Act1_Myyja)
            case '2':
                setAct(Act2_Myyja)
            case '3':
                console.log('tänne')
                setAct(Act3_Myyja)
            case '4':
                setAct(Act4_Myyja)
            case '5':
                setAct(Act5_Myyja)
            default:
                setAct(Act1_Myyja)
        }
        */
    }

    const setBuyer = () => {
        if (reduxStage === '1') {
            setAct(Act1_Vastaaja)
            return
        }

        if (reduxStage === '2') {
            setAct(Act2_Vastaaja)
            return
        }

        if (reduxStage === '3') {
            setAct(Act3_Vastaaja)
            return
        }

        if (reduxStage === '4') {
            setAct(Act4_Vastaaja)
            return
        }

        if (reduxStage === '5') {
            setAct(Act5_Vastaaja)
            return
        }

        /*
        jostain syystä ei toimi...
        switch (reduxStage) {
            case '1':
                setAct(Act1_Vastaaja)
            case '2':
                setAct(Act2_Vastaaja)
            case '3':
                setAct(Act3_Vastaaja)
            case '4':
                setAct(Act4_Vastaaja)
            case '5':
                setAct(Act5_Vastaaja)
            default:
                setAct(Act1_Vastaaja)
        }
        */
    }

    return (
        <div>
            <img className='act-progress-bar' src={act} alt="" />
            {/*<iframe src='http://localhost:3000/' width='200px' />*/}
        </div>
    )
}

export default Act